import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(orderDateStyles, {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    orderDate: {
        size: 14,
    },
});
